import { render, staticRenderFns } from "./RegistrarPontoColaborador.vue?vue&type=template&id=c5c8e24a"
import script from "./RegistrarPontoColaborador.vue?vue&type=script&lang=js"
export * from "./RegistrarPontoColaborador.vue?vue&type=script&lang=js"
import style0 from "./RegistrarPontoColaborador.vue?vue&type=style&index=0&id=c5c8e24a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports